import styled from '@emotion/styled'

export const FastFeatureControlWrapper = styled.div``

export const FastFeatureRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`

export const CheckboxLabel = styled.span`
  color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.7));
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`

export const SectionLabel = styled.p`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) =>
    theme && theme.colors ? theme.colors.blackSecondary : '#555'};
  margin: 0 0 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`
